import { get, post } from "./base";

const ChatServ = {
    getConversations: () => get("/chat/conversations"),
    getUnreadCount: () => get("/chat/unread-count"),
    getSupportAdmin: () => get("/chat/support-admin"),
    getMessages: (conversationId) => get(`/chat/messages/${conversationId}`),
    startConversation: (data) => post("/chat/start", data),
};

export default ChatServ;
